import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigurationControlService } from "../../services/configuration/configurationControl.service";
import { WelcomeService } from '../../services/welcome/welcome.service';
import { CONFIG } from '../../constants/constants';
import { TokenControlService } from '../state/tokenControl.service';
import { LoginService } from '../login/login.service';
import { OfflineService } from '../data/offline.service';
import { StateService } from '../state/state.service';

@Injectable({
  providedIn: 'root'
})
export class RoutingValidationService {

  private idPrueba: any;


  constructor(private _configurationControlService: ConfigurationControlService,
    private _welcomeDataService: WelcomeService,
    private _offlineService: OfflineService,
    private _loginService: LoginService,
    private _stateService: StateService,
    private _tokenController: TokenControlService,
    private _router: Router,) { }

  /** Método encargado de generar las validaciones necesarias para definir enrutamientos */
  public validateRouting(action: string) {
    this.idPrueba = this._configurationControlService.idPrueba
    switch (action) {
      case "login2Exam":
        if (this._configurationControlService.examConfiguration.hideWelcome) {
          this._router.navigate(['/terms']);
          break;
        } else if (this._configurationControlService.examConfiguration.showTerms != null) {
          this._router.navigate(['/terms']);
          break;
        } else if (this._configurationControlService.examConfiguration.typeTest == "1") {
          this._configurationControlService.startChrono = true;
          this._router.navigate(['/viewtest']);
          break;
        } else if (this._configurationControlService.examConfiguration.typeTest == "2") {
          this._configurationControlService.startChrono = true;
          this.validatePreIcfes();
          break;
        }
        break;
      case "welcomeToExam":
      case "tourToExam":
        if (this._configurationControlService.examConfiguration.showSimulation) {
          this._configurationControlService.startChrono = false;
          this._router.navigate(['/simulate']);
          break;
        } else if (this._configurationControlService.examConfiguration.typeTest == "1") {
          if (this._configurationControlService.tourWelcome) {
            this._configurationControlService.tourWelcome = false;
            this._configurationControlService.examConfiguration.showSimulation = true;
            this._configurationControlService.examConfiguration.showTerms = null;
            this.cargarWelcome()
          }
          else {
            this._configurationControlService.startChrono = true;
            this._router.navigate(['/viewtest']);
          }

          break;
        } else if (this._configurationControlService.examConfiguration.typeTest == "2") {
          this._configurationControlService.startChrono = true;
          this.validatePreIcfes();
          break;
        }
        break;

      case "simulateToExam":
        if (this._configurationControlService.examConfiguration.typeTest == "1") {
          this._configurationControlService.startChrono = true;
          this._router.navigate(['/viewtest']);
          break;
        } else if (this._configurationControlService.examConfiguration.typeTest == "2") {
          this._configurationControlService.startChrono = true;
          this.validatePreIcfes();
          break;
        }
        break;

      case "termsToTour":
        this._router.navigate(['/webTourOne']);
        break;

      case "logOut":
        console.log('Ejecutando logout. Estado actual:', this._tokenController.token);
        if (this._configurationControlService.esDemo) {
          if (this._configurationControlService.ambiente == "demo") {
            this._router.navigate(['/demo']);
          } else {
            this._router.navigate(['/preIcfes']);
          }
        } else {
          this._tokenController.token = null;
          this._configurationControlService.examConfiguration = null;
          this._router.navigate(["/login"], { replaceUrl: true });
        }
        break;
    }
  }

  /** Encargado de validar si se debe simular el examen de comunicacion escrita */
  public validatePreIcfes() {
    if (this.idPrueba == CONFIG.TEST_CODE_PI) {
      this._router.navigate(['/simulate']);
    } else {
      this._router.navigate(['/viewtestAdp']);
    }
  }

  private cargarWelcome() {
    if (CONFIG.ONLINE) {
      this._loginService.loadWelcomeInfo(this._tokenController.token.credentialId, this._tokenController.token.token,
        this._tokenController.token.tokenId, this._configurationControlService.examConfiguration != null ? this._configurationControlService.examConfiguration.multiplesesion : false)
        .then(res => {
          this._welcomeDataService.data = res;
          this._stateService.deadLine = null;
          this._router.navigate(['/welcome']);
        })
    }
    else {
      this._offlineService.getWelcomeDTO(
        this._tokenController.token.credentialId,
        this._tokenController.token.token,
        this._tokenController.token.tokenId,
        this._tokenController.token.sesion)
        .then(res => {
          this._welcomeDataService.data = res;
          this._stateService.deadLine = null;
          this._router.navigate(['/welcome']);
        })
    }
  }
}
